import React, { Fragment, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import { WidthContainer } from 'components/_new/layout/widthContainer'

import s from './Header.scss'


const useShadow = (fixed) => {
  const ref = useRef()

  useEffect(() => {
    if (fixed) {
      const handleScroll = () => {
        const { scrollingElement = document.body } = document

        if (scrollingElement.scrollTop > 0) {
          ref.current.classList.add(s.withShadow)
        }
        else {
          ref.current.classList.remove(s.withShadow)
        }
      }

      document.addEventListener('scroll', handleScroll)

      return () => {
        document.removeEventListener('scroll', handleScroll)
      }
    }
  }, [ fixed ])

  return ref
}

const Header = ({ children, className, fixed = false }) => {
  const ref = useShadow(fixed)

  const rootClassName = cx(className, s.header, {
    [s.fixed]: fixed,
  })

  const headerNode = (
    <div className={rootClassName} ref={ref}>
      <WidthContainer className={s.content}>
        {children}
      </WidthContainer>
    </div>
  )

  if (fixed) {
    return (
      <Fragment>
        {headerNode}
        <div className={s.backdrop} />
      </Fragment>
    )
  }

  return headerNode
}

Header.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  fixed: PropTypes.bool,
}


export default Header
